export default "__VITE_ASSET__dcff1ea7__"